// Copyright 2017 Sorama B.V.

export enum ChannelSelectionUsage {
    LiveStreaming,
    Recording,
}
